import React from 'react';
import Head from 'next/head';

import Raffle from '../../components/Raffle';
import Auction from '../../components/Auction';
import useRaffles from '../../hooks/useRaffles';

const ShopItem = ({ raffleKey, type }) => {
  switch (type) {
    case 'raffle':
      return <Raffle raffleKey={raffleKey} />;
    case 'auction':
      return <Auction raffleKey={raffleKey} />;
    default:
      return <Raffle raffleKey={raffleKey} />;
  }
};

const Shop = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  return (
    <>
      <Head>
        <title>{raffle.title} - Rainbow Shop | Noundles</title>
        <meta
          property="og:title"
          content={`${raffle.title} - Rainbow Shop | Noundles`}
          key="og:title"
        />
        <meta
          property="twitter:title"
          content={`${raffle.title} - Rainbow Shop | Noundles`}
          key="twitter:title"
        />
        <meta
          property="og:image"
          content={new URL(raffle.image, process.env.NEXT_PUBLIC_URL).href}
          key="og:image"
        />
        <meta
          property="twitter:image"
          content={new URL(raffle.image, process.env.NEXT_PUBLIC_URL).href}
          key="twitter:image"
        />
      </Head>
      <div className="pink-gradient">
        <div className="container py-5">
          <ShopItem raffleKey={raffleKey} type={raffle.type} />
        </div>
      </div>
    </>
  );
};

Shop.getInitialProps = async ({ query }) => {
  const { raffleKey } = query;
  return { raffleKey };
};

export default Shop;
